import { render, staticRenderFns } from "./NetPromoterPage.vue?vue&type=template&id=d0062a74&scoped=true&lang=html&"
import script from "./NetPromoterPage.vue?vue&type=script&lang=js&"
export * from "./NetPromoterPage.vue?vue&type=script&lang=js&"
import style0 from "./NetPromoterPage.vue?vue&type=style&index=0&id=d0062a74&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0062a74",
  null
  
)

export default component.exports